import NavigationDiallerComponent from "./NavigationDialler.component";

export * from "./NavigationDialler.component";
export default NavigationDiallerComponent;